import React, { useEffect, useState } from 'react';
import {
  Justify,
  Segment,
} from "tea-component";
import { getLocale } from 'umi';

import './index.scss';

export default function CardHead(props: any) {
  const { data, value: valueProps, title, onChange} = props
  const [value, setValue] = useState(valueProps);
  const isEN = getLocale() === 'en-US';
  useEffect(() => {
    setValue(value)
  }, [valueProps])
  return (
    <>
      <Justify className="card-head-justify"
        left={
          <Segment className={isEN ?  "segment-light" :  "segment-light segment-light-china"}
             value={value}
             onChange={(value: any) => {
               setValue(value)
               onChange(value)
             }}
             options={data} />
        }
      />
    </>
  )
}
